import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export const useScreenSize = (availableWidth?: undefined | number) => {
  const theme = useTheme()
  const { xs, sm, md, lg, xl } = theme.breakpoints.values
  let sizes = {
    // Larger than 1536
    isLargeDesktop: useMediaQuery(theme.breakpoints.up('xl')),

    // Larger than 1200
    isDesktop: useMediaQuery(theme.breakpoints.up('lg')),

    // Smaller than 600
    isMobile: useMediaQuery(theme.breakpoints.down('sm')),

    // Smaller than 444
    isSmallMobile: useMediaQuery(theme.breakpoints.down('xs')),

    // Between 600 and 900
    isSmallTablet: useMediaQuery(theme.breakpoints.between('sm', 'md')),

    // Between 600 and 1200
    isTablet: useMediaQuery(theme.breakpoints.between('sm', 'lg')),
  }

  if (availableWidth !== undefined) {
    sizes = {
      // Larger than 1536
      isLargeDesktop: availableWidth > xl,

      // Larger than 1200
      isDesktop: availableWidth > lg,

      // Smaller than 600
      isMobile: availableWidth < sm,

      // Smaller than 444
      isSmallMobile: availableWidth < xs,

      // Between 600 and 900
      isSmallTablet: availableWidth >= sm && availableWidth < md,

      // Between 600 and 1200
      isTablet: availableWidth > sm && availableWidth <= lg,
    }
  }

  return sizes
}
